import React from 'react'
import "./AdBanner.css";

const AdBanner = () => {
    return (
        <div>
            <p className='adbanner'>FESTIVE HAMPERS WITH ALL ORDERS ABOVE ₹1890 |FREE SHIPPING</p>
        </div>
    )
}

export default AdBanner
